import Table, { TCols } from 'components/Table';
import ActionCell from 'components/Table/Cells/ActionCell';
import MemberCell from 'components/Table/Cells/MemberCell';
import RoleCell from 'components/Table/Cells/RoleCell';
import React from 'react';
import { useAppSelector } from 'store/hooks';
import { selectSingleTeamsAgents } from 'store/slices/teams';
import ChangeRoleDialog from './ChangeRoleDialog';
import DeleteMemberDialog from './DeleteMemberDialog';

const SingleTeamTable = () => {
    const data = useAppSelector(selectSingleTeamsAgents);
    const { team, agents } = data;
    console.log('data', data);

    const columns: TCols = React.useMemo(
        () => [
            {
                field: 'user',
                headerName: 'Member',
                flex: 1,
                minWidth: 100,
                renderCell: ({ value, row }) => {
                    return <MemberCell name={value.fullName} avatar={undefined} email={value.email} />;
                },
            },
            {
                field: 'role',
                headerName: 'Role',
                flex: 1,
                minWidth: 100,
                renderCell: ({ value, row }) => <RoleCell data={value} />,
            },
            {
                field: 'actions',
                width: 40,
                renderCell: ({ value, row }: { value?: any; row: any }) => (
                    <ActionCell>
                        <ChangeRoleDialog user={row.user} teamName={team.title} />
                        <DeleteMemberDialog
                            name={row.user.fullName}
                            teamName={team.title}
                            email={row.user.email}
                            teamId={team.id}
                        />
                    </ActionCell>
                ),
                // renderCell: ({ row }) => {
                //     return row.status !== 'deleted' && <ModalDeleteApiKey id={row.id} preview={row.preview} />;
                // },
            },
        ],
        [],
    );

    return <Table columns={columns} rows={agents} />;
};

export default SingleTeamTable;
